import React, { Component } from "react";
import { TextField, Tooltip, IconButton } from "@mui/material";
import Grid from "@material-ui/core/Grid";
import { ValidatorForm } from "react-material-ui-form-validator";
import { TextValidator } from "react-material-ui-form-validator";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { withRouter } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetApp";
import axios from "../../../../axios-order";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import SelectField from "../../../../components/ui/basicSelectInput";

class form26asRepo extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      historyTable: [],
      historyTableOriginalData: [],
      loaderForTable: false,
      downloadingId: null,

      // upload
      file_name: "",
      GSTJsonfFile: "",

      // auto download
      financialYearsList: [],
      financial_year: "",
      availableYearsForDownload: [],

      // loaders
      loading: false,
      loadingAutoDownload: false,

      // disable flags
      disableFileUpload: false,
      disableAssessmentYear: false,
    };
  }

  componentDidMount() {
    this.getDetails();
    this.setFromYearValues();
    this.getAvailableYears();
  }

  /* ================= FILE UPLOAD ================= */
  fileUploader = (event) => {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => {
        this.setState({
          file_name: file.name,
          GSTJsonfFile: reader.result,

          // block other option
          disableAssessmentYear: true,
          disableFileUpload: false,
          financial_year: "",
        });
      };
      event.target.value = null;
    }
  };

      downloadPDF = (base64Data, fileName) => {
    const linkSource = base64Data;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  downloadFile = (document_id, document_name) => {
    this.setState({ downloadingId: document_id });
    axios
      .get(
        `/form_26/download_document/${localStorage.getItem(
          "business_entity_id"
        )}/${document_id}`
      )
      .then((res) => {
        if (typeof res.data === "undefined") {
        } else {
          this.downloadPDF(res.data.records, document_name);
        }
      })
      .finally(() => {
        this.setState({ downloadingId: null });
      });
  };

        getAvailableYears = () => {
    const businessEntityId = localStorage.getItem("business_entity_id");
    axios
      .get(`/get_available_years_for_auto_download/${businessEntityId}/26as`)
      .then((res) => {
        if (res.data.status === true && res.data.records.length > 0) {
          this.setState({ availableYearsForDownload: res.data.records });
        }
      })
      .catch((error) => {
        console.error("Error loading available years:", error);
      });
  };

  /* ================= YEAR CHANGE ================= */
  onChangeFinancialYear = (event) => {
    this.setState({
      financial_year: event.target.value,

      // block other option
      disableFileUpload: true,
      disableAssessmentYear: false,
      file_name: "",
      GSTJsonfFile: "",
    });
  };

  handleBackNavigation = () => {
  this.props.history.push("/repoCards"); 
};

  /* ================= SUBMIT (COMMON) ================= */
  onCombinedSubmitHandler = () => {
    if (this.state.file_name) {
      this.uploadFile();
    } else if (this.state.financial_year) {
      this.autoDownload26AS();
    } else {
      toast.error("Please upload file or select assessment year");
    }
  };

  uploadFile = () => {
    this.setState({ loading: true });

    axios
      .post(`/form26/tdsrepository`, {
        file: this.state.GSTJsonfFile,
        document_name: this.state.file_name,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then(() => {
        toast.success("File uploaded successfully");
        this.resetForm();
        this.getDetails();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Upload failed");
      })
      .finally(() => this.setState({ loading: false }));
  };

  autoDownload26AS = () => {
    this.setState({ loadingAutoDownload: true });

    axios
      .post(`/auto_download_26as_repository`, {
        assessment_year: this.state.financial_year,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then(() => {
        toast.success("26AS auto download started");
        this.resetForm();
        this.getDetails();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Auto download failed");
      })
      .finally(() => this.setState({ loadingAutoDownload: false }));
  };

  /* ================= CANCEL ================= */
  resetForm = () => {
    this.setState({
      file_name: "",
      GSTJsonfFile: "",
      financial_year: "",
      disableFileUpload: false,
      disableAssessmentYear: false,
    });
  };



  /* ================= HISTORY ================= */
  getDetails = () => {
    this.setState({ loaderForTable: true });
    axios
      .get(`/form26/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data?.status) {
          this.setState({
            historyTable: res.data.records,
            historyTableOriginalData: res.data.records,
          });
        }
      })
      .finally(() => this.setState({ loaderForTable: false }));
  };

  historyTableHeader = () => (
    <>
      <th>DOCUMENT NAME</th>
      <th>FINANCIAL YEAR</th>
      <th>UPLOADED TIME</th>
      <th>FILE UPDATED</th>
      <th>ACTIONS</th>
    </>
  );

  historyTableData = () => {
    if (this.state.loaderForTable) {
      return (
        <tr>
          <td colSpan="5" style={{ textAlign: "center" }}>
            Loading…
          </td>
        </tr>
      );
    }

    if (!this.state.historyTable.length) {
      return (
        <tr>
          <td colSpan="5" style={{ color: "red" }}>
            No data found!
          </td>
        </tr>
      );
    }

    return this.state.historyTable.map((row, i) => (
      <tr key={i}>
        <td>{row.document_name}</td>
        <td>{row.financial_year}</td>
        <td>{row.uploaded_time}</td>
        <td>{row.file_updated}</td>
         <td>
          {this.state.downloadingId === row.document_id ? (
            <span
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid #1976d2",
                borderTopColor: "transparent",
                borderRadius: "50%",
                display: "inline-block",
                animation: "spin 0.7s linear infinite",
              }}
            />
          ) : (
              <GetAppIcon
                className="action-icon-button download"
                onClick={() => this.downloadFile(row.document_id, row.document_name)}
              style={{ cursor: "pointer" }}
              />
          )}
            </td>
      </tr>
    ));
  };

  setFromYearValues = () => {
    const year = new Date().getFullYear();
    const list = [];
    for (let i = year - 10; i <= year + 1; i++) {
      list.push({ id: `${i}-${i + 1}`, year: `${i}-${i + 1}` });
    }
    this.setState({ financialYearsList: list });
  };

  /* ================= ASSESSMENT YEAR SELECT ================= */
  assessmentYearSelect = () => {
    const yearsToShow =
      this.state.availableYearsForDownload.length > 0
        ? this.state.financialYearsList.filter((fy) =>
          this.state.availableYearsForDownload.includes(fy.id)
        )
        : this.state.financialYearsList;

    return (
      <div
        style={{
        opacity: this.state.disableAssessmentYear ? 0.5 : 1,
        pointerEvents: this.state.disableAssessmentYear ? "none" : "auto",
          backgroundColor: this.state.disableAssessmentYear
            ? "#f5f5f5"
            : "transparent",
          borderRadius: "4px",
        }}
      >
        <SelectField
          SelectLabel="Assessment Year"
          choices={yearsToShow}
          choice_id="id"
          choice_name="year"
          value={this.state.financial_year}
          disabled={this.state.disableAssessmentYear}
          textOnchangeFunction={this.onChangeFinancialYear}
        />
      </div>
    );
  };

  /* ================= RENDER ================= */
  render() {
    return (
      <React.Fragment>
            <div style={{
                  padding: "15px 20px",
                  backgroundColor: "#f5f5f5"
                }}>
                  <Tooltip title="Back" arrow>
                                         <IconButton
                                           onClick={this.handleBackNavigation}
                                           sx={{
                                             borderRadius: '50%',
                                             padding: '6px',
                                             color: '#263238',
                                             fontSize: '20px',
                                             backgroundColor: '#ffffff',
                                             height: '36px',
                                             width: '36px',
                                             '&:hover': {
                                               backgroundColor: '#455a64',
                                               color: '#ffffff',
                                             },
                                             boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                             transition: 'background-color 0.3s ease',
                                           }}
                                         >
                                           <ArrowBackIcon sx={{ fontSize: '20px' }} />
                                         </IconButton>
                                       </Tooltip>
                </div>
        {/* ===== 26AS-TDS BOX ===== */}
        <BoxWrapper boxTitle="26AS-TDS">
          <ValidatorForm onSubmit={this.onCombinedSubmitHandler}>

            <div style={{ display: "flex", alignItems: "flex-end", gap: "25px", flexWrap: "wrap" }}>

              {/* UPLOAD BUTTON */}
              <div style={{ width: "120px" }}>
                <label
                  className="button-primary"
                  style={{
                    cursor: this.state.disableFileUpload ? "not-allowed" : "pointer",
                    opacity: this.state.disableFileUpload ? 0.5 : 1,
                    padding: "8px 16px",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "100%",
                    textAlign: "center",
                    display: "inline-block",
                    backgroundColor: this.state.disableFileUpload ? "#cccccc" : "",
                    pointerEvents: this.state.disableFileUpload ? "none" : "auto"
                  }}
                >
                  UPLOAD
                  <input
                    type="file"
                    hidden
                    disabled={this.state.disableFileUpload}
                    accept="application/pdf,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    onChange={this.fileUploader}
                  />
                </label>
              </div>

              {/* FILE NAME INPUT */}
              <div style={{ width: "300px" }}>
                <TextValidator
                  value={this.state.file_name}
                  placeholder="Choose file"
                  fullWidth
                  disabled={this.state.disableFileUpload}
                  inputProps={{ 
                    readOnly: true,
                    style: {
                      backgroundColor: this.state.disableFileUpload ? "#f5f5f5" : "white",
                      color: this.state.disableFileUpload ? "#999" : "black",
                      cursor: this.state.disableFileUpload ? "not-allowed" : "text"
                    }
                  }}
                  style={{
                    opacity: this.state.disableFileUpload ? 0.6 : 1
                  }}
                />
              </div>

              {/* ASSESSMENT YEAR */}
              <div style={{ width: "300px" }}>
                {this.assessmentYearSelect()}
              </div>

              {/* BUTTONS */}
              <div style={{ display: "flex", gap: "10px" }}>
                {(this.state.loading || this.state.loadingAutoDownload) ? (
                  <div style={{ 
                    padding: "8px 16px", 
                    fontSize: "13px",
                    fontWeight: "500"
                  }}>
                    Processing...
                  </div>
                ) : (
                  <button
                    className="button-primary"
                    type="submit"
                    style={{
                      padding: "8px 20px",
                      fontSize: "13px",
                      fontWeight: "500",
                      minWidth: "90px"
                    }}
                  >
                    SUBMIT
                  </button>
                )}
                <button
                  className="button-outlined-secondary"
                  type="button"
                  onClick={this.resetForm}
                  style={{
                    padding: "8px 20px",
                    fontSize: "13px",
                    fontWeight: "500",
                    minWidth: "90px"
                  }}
                >
                  CANCEL
                </button>
              </div>

            </div>
          </ValidatorForm>
        </BoxWrapper>

        {/* ===== HISTORY ===== */}
        <BoxWrapper boxTitle="History">
          <div className="responsive-table">
            <table className="custome-table">
              <tbody>
                <tr>{this.historyTableHeader()}</tr>
                {this.historyTableData()}
              </tbody>
            </table>
          </div>
        </BoxWrapper>

      </React.Fragment>
    );
  }
}
export default withRouter(form26asRepo);